var config = {
  disabled: false
};

export { config as default };
